import { memo, useCallback } from 'react';

import { useTrackOpenInMobileAppClicked } from '@air/analytics';
import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { TabletSmartphoneIcon } from '@air/design-icons';

import { useIsIosMobileDevice } from '~/hooks/useIsIosMobileDevice';
import { useMobileHandoffUrl } from '~/hooks/useMobileHandoffUrl';

export const SidebarNavigationItemOpenMobileApp = memo(() => {
  const { isIosMobileDevice } = useIsIosMobileDevice();
  const { trackOpenInMobileAppClicked } = useTrackOpenInMobileAppClicked();
  const handoffUrl = useMobileHandoffUrl();

  const handleOpenMobileApp = useCallback(() => {
    trackOpenInMobileAppClicked({ location: 'mobile_nav' });
  }, [trackOpenInMobileAppClicked]);

  const canShowOpenMobileApp = isIosMobileDevice && Boolean(handoffUrl);

  if (!canShowOpenMobileApp || !handoffUrl) {
    return null;
  }

  return (
    <SidebarNavigationItem
      asChild
      data-testid="SIDEBAR_NAVIGATION_ITEM_OPEN_MOBILE_APP"
      onClick={handleOpenMobileApp}
      prefix={<TabletSmartphoneIcon size="sm" />}
    >
      <a href={handoffUrl}>Open in mobile app</a>
    </SidebarNavigationItem>
  );
});

SidebarNavigationItemOpenMobileApp.displayName = 'SidebarNavigationItemOpenMobileApp';
